import { getUserPrivate } from '@db/Users';
import { getCurrentUserId } from '@helpers/firebase/Auth';
import db, { parseFirestoreDoc, updateDocWithTimestamps } from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { Notification } from '@types';

function parseNotificationDoc(doc: db.DocumentSnapshot) {
  return parseFirestoreDoc<Notification>(doc, 'notificationId');
}

export async function addUserNotificationToken(token: string) {
  const currentUserId = getCurrentUserId();
  await updateDocWithTimestamps(
    db.doc(firestore, 'users', currentUserId, 'private', currentUserId),
    { notificationToken: token }
  );
}

export async function getUserNotificationToken() {
  const currentUserId = getCurrentUserId();
  const privateDoc = await getUserPrivate(currentUserId);
  return privateDoc.notificationToken;
}

export async function deleteUserNotificationToken() {
  const currentUserId = getCurrentUserId();
  return await updateDocWithTimestamps(
    db.doc(firestore, 'users', currentUserId, 'private', currentUserId),
    {
      notificationToken: db.deleteField(),
    }
  );
}

export async function getUserNotifications(constraints: db.QueryConstraint[] = []) {
  const currentUserId = getCurrentUserId();
  const querySnapshot = await db.getDocs(
    db.query(db.collection(firestore, 'users', currentUserId, 'notifications'), ...constraints)
  );
  return querySnapshot.docs.map((doc) => parseNotificationDoc(doc));
}

export async function deleteNotification(notificationId: string) {
  const currentUserId = getCurrentUserId();
  await db.deleteDoc(db.doc(firestore, 'users', currentUserId, 'notifications', notificationId));
}

export async function updateNotificationRead(notificationId: string) {
  const currentUserId = getCurrentUserId();
  await updateDocWithTimestamps(
    db.doc(firestore, 'users', currentUserId, 'notifications', notificationId),
    {
      read: true,
    }
  );
}

export function listenToNotifications(
  onNotification: (notifications: Notification[]) => void,
  onError: (error: db.FirestoreError) => void,
  constraints: db.QueryConstraint[] = []
) {
  const currentUserId = getCurrentUserId();
  const q = db.query(
    db.collection(firestore, 'users', currentUserId, 'notifications'),
    ...constraints
  );
  const onSnapshot = (snapshot: db.QuerySnapshot<db.DocumentData>) => {
    const notifications = snapshot.docs.map((doc) => parseNotificationDoc(doc));
    onNotification(notifications);
  };
  return db.onSnapshot(q, onSnapshot, onError);
}
